import clsx from "clsx";
import type { ReactNode } from "react";

export interface GuardiansToolbarAnimatedSlotProps {
  visible: boolean;
  children: ReactNode;
  /**
   * When true (default), participates in workbench toolbar width math and clips
   * overflow (e.g. New Audit). When false, only fades/slides in — use for
   * controls with popovers (Filters).
   */
  asWorkbenchSlot?: boolean;
}

/** Expands between filters and settings; search/filters shift left as it fades in. */
export function GuardiansToolbarAnimatedSlot({
  visible,
  children,
  asWorkbenchSlot = true,
}: GuardiansToolbarAnimatedSlotProps) {
  return (
    <div
      className={clsx(
        "grid min-w-0 transition-[grid-template-columns,opacity] duration-200 ease-out",
        visible
          ? "grid-cols-[1fr] shrink opacity-100"
          : "pointer-events-none grid-cols-[0fr] opacity-0"
      )}
      aria-hidden={!visible}
      data-testid="guardians-toolbar-slot"
      {...(asWorkbenchSlot ? { "data-workbench-toolbar-slot": true } : {})}
      data-visible={visible ? "true" : "false"}
    >
      <div
        className={clsx("min-w-0", asWorkbenchSlot ? "overflow-hidden" : "overflow-visible")}
      >
        {children}
      </div>
    </div>
  );
}
